/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { createBrowserHistory } from 'history'
import { SettingsManager } from './configuration/SettingsManager'
import $script from 'scriptjs'
import { Drawer } from './views/Drawer/Drawer'
import { Menu } from './views/Menu/Menu'

import { IUserSessionMiddleware } from './arc/middleware/UserSessionMiddleware/contracts'
import { container } from './arc/configuration/ServiceLocator'

// create the browser history
export const history = createBrowserHistory({
	basename: process.env.PUBLIC_URL,
})

//
const getUrlVars = (): { [key: string]: string } => {
	const result: { [key: string]: string } = {}
	window.location.href
		.slice(window.location.href.indexOf('?') + 1)
		.split('&')
		.forEach(element => {
			const hash: string[] = element.split('=')
			result[hash[0]] = hash[1]
		})
	return result
}

// ensure appConfig.js is loaded without caching
$script(`${process.env.PUBLIC_URL}/appConfig.js?_=${Date.now()}`, () => {
	// configure the container... this must be done BEFORE rendering the App but AFTER importing service locator
	SettingsManager.configureContainer()

	if (SettingsManager.REACT_APP_INJECT_SSO_TOKEN().value) {
		localStorage.setItem(SettingsManager.REACT_APP_SSO_TOKEN_NAME, SettingsManager.REACT_APP_HARD_CODED_SSO_JWT().value)
	}

	const userSessionMiddleware = container.get<IUserSessionMiddleware>('IUserSessionMiddleware')
	userSessionMiddleware.loadSessionJwt().then(() => {
		// if the url querystring contains ...loadPartial=drawer... then only load the drawer and not the rest of the app
		if (getUrlVars()['loadPartial'] === 'drawer') {
			ReactDOM.render(<Drawer />, document.getElementById('root'))
		} else if (getUrlVars()['loadPartial'] === 'menu') {
			ReactDOM.render(<Menu />, document.getElementById('root'))
		} else {
			ReactDOM.render(<App />, document.getElementById('root'))
		}
	})

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorker.unregister()
})
